export default "__VITE_ASSET__X04jYseO__"